"use client";
import BFLTabs from "@repo/shared-ui/BFLTabs";
import { handleShareholdingPatternTabDL } from "../StockFinancials/BFLTabsFunction";
import { selectLoginStatus, useAppSelector } from "@repo/web-store";
interface Props {
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
  SHARE_HOLDING_TAB: Record<"shs" | "hph" | "hmfh" | "hFiih", string>;
}
const StockShareHoldingTab = ({
  selectedTab,
  setSelectedTab,
  SHARE_HOLDING_TAB,
}: Props) => {
  const loginStatus = useAppSelector(selectLoginStatus);
  const tabs = Object.entries(SHARE_HOLDING_TAB).map(([key, value]) => ({
    label: value ?? "",
    value: value ?? "",
  }));

  /**
   * Handle tab change with GA tracking for shareholding pattern
   */
  const handleTabChange = (newTab: string) => {
    // Find the tab position
    const tabPosition = tabs.findIndex((tab) => tab.value === newTab) + 1;

    // Get the tab label
    const tabLabel = tabs.find((tab) => tab.value === newTab)?.label || newTab;

    // Track the tab click
    handleShareholdingPatternTabDL(loginStatus, {
      sectionTitle: "Shareholding Pattern",
      ctaText: tabLabel,
      tabPosition: tabPosition,
    });

    // Set the selected tab
    setSelectedTab(newTab);
  };
  return (
    <div className="flex gap-3" data-component-id="shareholding-pattern">
      <BFLTabs
        tabs={tabs || []}
        selectedTab={selectedTab}
        onTabChange={handleTabChange}
        tabClassName="mr-3 md:mr-4 pb-[1px]"
        gapClassName="md:pb-[14px]"
      />
    </div>
  );
};
export default StockShareHoldingTab;
